import { ContentPageBody } from "@containers/common/content-page-body/content-page-body";
import { ContentPageHeader } from "@containers/common/content-page-header/content-page-header";
import { AttributeTypes } from "@iddataweb/idw-common-ui/enums";
import { AXNUIContent, AXNUIContentForm } from "@iddataweb/idw-common-ui/types";
import { WorkflowGeneralAttributesValidationErrors } from "@idw-types/common/validation/workflow-details-validation-errors";
import { AttributeLabel, AttributeTypeFieldsMap } from "@idw-types/data/reference-data/generic";
import { FormattedRpServiceConfigurationAttribute } from "@idw-types/data/rp-service-configuration";
import { WorkflowDetailsAttributeContainer } from "./workflow-details-attribute-container/workflow-details-attribute-container";

type WorkflowDetailsAttributesTabProps = {
    isDisabled: boolean;
    formattedRpServiceAttributes: Array<FormattedRpServiceConfigurationAttribute>;
    axnuiContent: AXNUIContent;
    axnAttributeTypeFieldMap: AttributeTypeFieldsMap;
    attributeLabels: Array<AttributeLabel>;
    validationErrors: WorkflowGeneralAttributesValidationErrors;
    setAttributeLabel: (attributeTypeName: AttributeTypes, value: string) => void;
    setAttributeForm: (attributeTypeName: AttributeTypes, key: keyof AXNUIContentForm, value: string) => void;
}
export const WorkflowDetailsAttributesTab = (props: WorkflowDetailsAttributesTabProps) => {
    const { isDisabled, formattedRpServiceAttributes, axnuiContent, attributeLabels, validationErrors, axnAttributeTypeFieldMap, setAttributeLabel, setAttributeForm } = props;

    const handleUpdateAttributeLabel = (value: string, attributeTypeName: AttributeTypes) => {
        setAttributeLabel(attributeTypeName, value);
    }

    return <div>
        <ContentPageHeader title={"Attributes"} />
        <ContentPageBody isMaxWidth={true}>
            {formattedRpServiceAttributes.map((attribute, index) =>
                <WorkflowDetailsAttributeContainer
                    key={`workflow-details-attribute-${index}`}
                    attribute={attribute}
                    isDisabled={isDisabled}
                    axnuiContentLabels={axnuiContent.labels}
                    axnuiContentForm={axnuiContent.form}
                    axnAttributeTypeFieldMap={axnAttributeTypeFieldMap}
                    attributeLabels={attributeLabels}
                    validationErrors={validationErrors.validationErrors[attribute.attributeType?.name]}
                    handleAttributeLabelChange={handleUpdateAttributeLabel}
                    setAttributeForm={setAttributeForm}
                />
            )}

        </ContentPageBody>
    </div>
};